import { render } from "./TamButton.vue?vue&type=template&id=58daaaaf"
import script from "./TamButton.vue?vue&type=script&lang=js"
export * from "./TamButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__